import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { HomeDailyLessonVolumeIntro } from './home_daily_lesson_volume_intro';
export const HomeDailyLessonVolumeDivider = ({ volumeNumber, isFirstVolume, classObject }) => {
    return (React.createElement("div", { className: css(styles.divider, isFirstVolume && styles.firstVolumeHeader, classObject) },
        isFirstVolume && React.createElement(HomeDailyLessonVolumeIntro, null),
        React.createElement("div", { className: css(styles.inner) },
            React.createElement("span", { className: css(styles.line) }),
            React.createElement("span", { className: css(styles.label) }, `Vol. ${volumeNumber}`),
            React.createElement("span", { className: css(styles.line) }))));
};
const styles = StyleSheet.create({
    divider: {
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: 375,
        paddingTop: 32,
        paddingRight: 24,
        paddingBottom: 32,
        paddingLeft: 24,
    },
    firstVolumeHeader: {
        paddingTop: 30,
    },
    inner: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        paddingTop: 6,
        paddingBottom: 6,
    },
    line: {
        width: 116,
        height: 1,
        backgroundColor: Colors.Gray,
        flexShrink: 0,
    },
    label: {
        fontSize: 16,
        lineHeight: 1,
        color: Colors.GrayDarkest,
        flexShrink: 0,
    },
});
